

const Form = (props) => {

    return(
        <form onSubmit={props.handleSubmit}>

            <legend>Do you want to discover some podcasts? Enter your keyword, and click on the Search Podcast button! You may select a country or genre to help with the search results. Enjoy!</legend>

            <label htmlFor="userKeyword" className="sr-only">Enter a keyword</label>
            <input type="text" 
            id="userKeyword" 
            placeholder="Keyword" 
            onChange={props.handleChange} 
            aria-describedby="error" 
            value={props.typedValue} required
            />

            <label htmlFor="countrySelection" className="sr-only">Select a country</label>
            <select name="countrySelection" id="countrySelection" onChange={props.handleCountry}>
                {countryCodes.map((codes) => {
                    return <option key={codes}>{codes}</option>
                })}
            </select>

            <label htmlFor="genre" className="sr-only">Select a genre</label>
            <select name="genre" id="genre" onChange={props.handleGenre}>
                {genreCodes.map((genre)=>{
                    return <option key={genre}>{genre}</option>
                })}
            </select>

            <button>Search Podcast</button>

            {
                props.formError
                    ? <h2 className="error">
                        This search is not valid. Please try again!
                    </h2>
                    : null
            }


        </form>
    )
}

const genreCodes = [
    'Society & Culture',
    'Comedy',
    'True Crime',
    'Spirituality',
    'Relationships',
    'Education',
    'History',
    'Politics',
    'News',
    'TV & Film',
    'Business',
    'Technology',
    'Arts',
    'Books',
    'Careers',
    'Personal Journals',
    'Health & Fitness',
    
]

const countryCodes = [
'US',
'CA',
"AF", 
"AX", 
"AL", 
"DZ", 
"AS", 
"AD", 
"AO", 
"AI", 
"AQ", 
"AG", 
"AR", 
"AM", 
"AW", 
"AU", 
"AT", 
"AZ", 
"BS", 
"BH", 
"BD", 
"BB", 
"BY", 
"BE", 
"BZ", 
'BJ', 
'BM', 
'BT', 
'BO', 
'BQ', 
'BA', 
'BW', 
'BV', 
'BR', 
'IO', 
'BN', 
'BG', 
'BF', 
'BI', 
'KH', 
'CM', 
'CV', 
'KY', 
'CF', 
'TD', 
'CL', 
'CN', 
'CX', 
'CC', 
'CO', 
'KM', 
'CG', 
'CD', 
'CK', 
'CR', 
'CI', 
'HR', 
'CU', 
'CW', 
'CY', 
'CZ', 
'DK', 
'DJ', 
'DM', 
'DO', 
'EC', 
'EG', 
'SV', 
'GQ', 
'ER', 
'EE', 
'ET', 
'FK', 
'FO', 
'FJ', 
'FI', 
'FR', 
'GF', 
'PF', 
'TF', 
'GA', 
'GM', 
'GE', 
'DE', 
'GH', 
'GI', 
'GR', 
'GL', 
'GD', 
'GP', 
'GU', 
'GT', 
'GG', 
'GN', 
'GW', 
'GY', 
'HT', 
'HM', 
'VA', 
'HN', 
'HK', 
'HU', 
'IS', 
'IN', 
'ID', 
'IR', 
'IQ', 
'IE', 
'IM', 
'IL', 
'IT', 
'JM', 
'JP', 
'JE', 
'JO', 
'KZ', 
'KE', 
'KI', 
'KP', 
'KR', 
'XK', 
'KW', 
'KG', 
'LA', 
'LV', 
'LB', 
'LS', 
'LR', 
'LY', 
'LI', 
'LT', 
'LU', 
'MO', 
'MK', 
'MG', 
'MW', 
'MY', 
'MV', 
'ML', 
'MT', 
'MH', 
'MQ', 
'MR', 
'MU', 
'YT', 
'MX', 
'FM', 
'MD', 
'MC', 
'MN', 
'ME', 
'MS', 
'MA', 
'MZ', 
'MM', 
'NA', 
'NR', 
'NP', 
'NL', 
'AN', 
'NC', 
'NZ', 
'NI', 
'NE', 
'NG', 
'NU', 
'NF', 
'MP', 
'NO', 
'OM', 
'PK', 
'PW', 
'PS', 
'PA', 
'PG', 
'PY', 
'PE', 
'PH', 
'PN', 
'PL', 
'PT', 
'PR', 
'QA', 
'RS', 
'RE', 
'RO', 
'RU', 
'RW', 
'BL', 
'SH', 
'KN', 
'LC', 
'MF', 
'PM', 
'VC', 
'WS', 
'SM', 
'ST', 
'SA', 
'SN', 
'CS', 
'SC', 
'SL', 
'SG', 
'SX', 
'SK', 
'SI', 
'SB', 
'SO', 
'ZA', 
'GS', 
'SS', 
'ES', 
'LK', 
'SD', 
'SR', 
'SJ', 
'SZ', 
'SE', 
'CH', 
'SY', 
'TW', 
'TJ', 
'TZ', 
'TH', 
'TL', 
'TG', 
'TK', 
'TO', 
'TT', 
'TN', 
'TR', 
'XT', 
'TM', 
'TC', 
'TV', 
'UG', 
'UA', 
'AE', 
'GB',  
'UM', 
'UY', 
'UZ', 
'VU', 
'VE', 
'VN', 
'VG', 
'VI', 
'WF', 
'EH', 
'YE', 
'ZM', 
'ZW' 
]

export default Form;

